import FancyMarket from '../normal/FancyMarket'

/**
 * Meter market (mname === "meter") — reference `.market-6` fancy block.
 */
function Meter({ onBetLockClick, marketsData = [], exposureData = {}, index }) {
  return (
    <FancyMarket
      marketName="meter"
      betLockName="Meter"
      layout="noyes"
      index={index ?? 5}
      onBetLockClick={onBetLockClick}
      marketsData={marketsData}
      exposureData={exposureData}
    />
  )
}

export default Meter
